import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { ProgressBar } from '@progress/kendo-react-progressbars';
import { StackLayout } from '../../../ui';
import { ValueItem } from '../../shared/components';

class MyHoursSummary extends React.PureComponent {
  render() {
    const localizationService = provideLocalizationService(this);
    const { summary } = this.props;

    if (!summary) {
      return null;
    }

    const approvedMinutes = summary.approvedMinutes || 0;
    const pendingMinutes = summary.pendingMinutes || 0;
    const targetMinutes = summary.targetMinutes || 1;
    const percentage = Math.min(Math.round(approvedMinutes / targetMinutes * 100), 100);

    return (
      <StackLayout rowGap='8px'>
        <ValueItem
          label={localizationService.toLanguageString('myGeneralCompetencyHours.approved')}
          labelWidth='108px'
        >
          {`${approvedMinutes} / ${targetMinutes} ${localizationService.toLanguageString('myGeneralCompetencyHours.minutes')} (${percentage}%)`}
        </ValueItem>
        <ValueItem
          label={localizationService.toLanguageString('myGeneralCompetencyHours.pending')}
          labelWidth='108px'
        >
          {`${pendingMinutes} ${localizationService.toLanguageString('myGeneralCompetencyHours.minutes')}`}
        </ValueItem>
        <ProgressBar value={percentage} labelVisible={false} />
      </StackLayout>
    );
  }
}

const mapStateToProps = state => ({
  summary: state.myGeneralCompetencyHoursListPage.summary
});

registerForLocalization(MyHoursSummary);

export default connect(mapStateToProps)(MyHoursSummary);
